<template>
  <div class="simular-group">
    <a-collapse accordion @change="changeCollapse">
      <a-collapse-panel
        :key="group.identifier"
        :header="`${group.name}: ${devices ? devices.length : 0}`"
        :class="danger ? 'simular-group__danger' : ''"
      >
        <div class="group">
          <div v-for="(device, index) in charges" :key="index" class="items">
            <slot name="device" :device="device"></slot>
          </div>
        </div>
        <template slot="extra">
          <slot name="options"></slot>
          <a-popover title="Upload Stamp" v-if="!hideUploadStamp">
            <template slot="content">
              <p>
                Upload Stamp Reference for group: <b>{{ group.name }}</b>
              </p>
            </template>
            <a-button
              type="link"
              icon="cloud-upload"
              size="small"
              @click="uploadStamp"
            />
          </a-popover>
          <a-popover title="Alert" v-if="!hideDelete">
            <template slot="content">
              <p>
                Delete group <b>{{ group.name }}</b>
              </p>
            </template>
            <a-button
              type="link"
              icon="delete"
              size="small"
              @click="deleteGroup(group)"
            />
          </a-popover>
        </template>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import {
  destroySimilarGroup,
  updateStampSimilarGroup,
} from "@/api/catalog-api/similar-group-api/similarGroup.api.js";

export default {
  props: {
    identifier: String,
    group: Object,
    hideDelete: Boolean,
    hideUploadStamp: Boolean,
    danger: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      charges: [],
    };
  },
  computed: {
    devices() {
      const { group } = this;
      if (!group || !group.devices) return;
      return group.devices.filter((d) => d !== null);
    },
  },
  methods: {
    async changeCollapse(v) {
      if (!v || this.charges.length || !this.devices) return;
      const sleep = (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
      };

      for (let i = 0; i < this.devices.length; i++) {
        await sleep(50).then((v) => {
          if (this.charges && !this.charges.includes(this.devices[i]))
            this.charges.push(this.devices[i]);
        });
      }
    },
    uploadStamp() {
      const i = document.createElement("input");
      i.type = "file";
      i.accept = ".png";
      i.onchange = () => {
        const { id } = this.group;
        const stamp = i.files[0] ? i.files[0] : null;
        if (stamp) return updateStampSimilarGroup({ stamp, id });
        return;
      };
      i.click();
    },
    deleteGroup(group) {
      const r = confirm(`Are you sure destroy "${group.name}" group?`);
      if (r)
        return destroySimilarGroup(group).then((response) =>
          this.$emit("change")
        );
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.simular-group {
  margin-bottom: 12px;

  .simular-group__danger {
    background: $danger_color;
  }
}

.group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.items {
  margin: 9px;
}
</style>
